// src/properties/display.ts
var displayProps = function displayProps(_ref) {
  var display = _ref.display;
  return display !== void 0 ? "display: ".concat(display, ";") : "";
};
export { displayProps };